import { BaseDto } from 'src/dtos/common/baseDto';

/** MST2020 거래처별 기초잔액 조회/저장 DTO */
export interface MST2020_R01Dto extends BaseDto {
	compCd: string;
	customCd: string;
	customNm: string;
	purchaseAmt: number;
	salesAmt: number;
	receiptAmt: number;
	paymentAmt: number;
	balanceAmt: number;
	remark: string;

	inserted?: boolean;
	isModified?: boolean;
}

/** 그리드 기본값 */
export const defaultMST2020_R01Dto: MST2020_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	compCd: '1000',
	customCd: '',
	customNm: '',
	purchaseAmt: 0,
	salesAmt: 0,
	receiptAmt: 0,
	paymentAmt: 0,
	balanceAmt: 0,
	remark: '',

	inserted: false,
	isModified: false,
};

/** 잔액 = 매출 - 매입 + 지불 - 수금 */
export const calcBalance = (
	row: Partial<MST2020_R01Dto>,
): number =>
	Number(row.salesAmt ?? 0)
	- Number(row.purchaseAmt ?? 0)
	+ Number(row.paymentAmt ?? 0)
	- Number(row.receiptAmt ?? 0);
